import { render, staticRenderFns } from "./MetadataTab.vue?vue&type=template&id=528d5500&scoped=true"
import script from "./MetadataTab.component.js?vue&type=script&lang=js&external"
export * from "./MetadataTab.component.js?vue&type=script&lang=js&external"
import style0 from "./MetadataTab.vue?vue&type=style&index=0&id=528d5500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d5500",
  null
  
)

export default component.exports